var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"condition-container-item"},[_c('flow-container',{attrs:{"children":_vm.tpl.children}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }